// Near-expiry classification for inventory badges. Alert-only; never mutates stock.
// Configurable thresholds (days). Defaults: URGENT<=15, SOON<=30.
export function expiryStatus(expiryDate, { urgent = 15, soon = 30 } = {}) {
  if (!expiryDate) return { code: "BATCH_NOT_RECORDED", label: "Batch not recorded", days: null };
  const exp = new Date(expiryDate);
  if (isNaN(exp.getTime())) return { code: "BATCH_NOT_RECORDED", label: "Batch not recorded", days: null };
  const days = Math.floor((exp - new Date()) / 86400000);
  if (days < 0) return { code: "EXPIRED", label: "Expired", days };
  if (days <= urgent) return { code: "URGENT", label: `Urgent · ${days}d`, days };
  if (days <= soon) return { code: "EXPIRING_SOON", label: `Expiring · ${days}d`, days };
  return { code: "SAFE", label: `Safe · ${days}d`, days };
}

export const EXPIRY_CLS = {
  SAFE: "border-emerald-200 bg-emerald-50 text-emerald-700",
  EXPIRING_SOON: "border-amber-200 bg-amber-50 text-amber-700",
  URGENT: "border-orange-300 bg-orange-50 text-orange-700",
  EXPIRED: "border-rose-300 bg-rose-50 text-rose-700",
  BATCH_NOT_RECORDED: "border-stone-200 bg-stone-100 text-stone-500",
};
